/**
 * 门户文本默认配置数据
 */
export const home = [{}]

/**
 * 大屏文本默认配置数据
 */
export const bs = [{}]

/**
 * app文本默认配置数据
 */
export const appHome = [
  {
    top: 0,
    left: 0,
    width: 100,
    widthType: "%",
  }
]
